import { Box } from '@mui/material';
import { useRouter } from 'next/router';
import { useContext } from 'react';

import Button from '@/contents/General/Button';
import Icon from '@/contents/General/Icon';
import { Board } from '@/contents/General/Panels';
import Stack from '@/contents/General/Stack';
import Typography from '@/contents/General/Typography';
import { GlobalContext } from '@/contents/hooks/state';
import useGetLoginUser from '@/modules/User/user/useGetLoginUser';
import theme from '@/styles/theme';

const BeforeUploadPhoto = ({ campSiteId }: { campSiteId: string }) => {
  const router = useRouter();
  const { isLogin } = useGetLoginUser();
  const { dialogStatus, setDialogStatus } = useContext(GlobalContext);

  const nextPage = (path: string) => {
    setDialogStatus({ ...dialogStatus, open: false });
    if (isLogin) {
      return router.push(path);
    }
    return router.push(`/login?redirect`);
  };

  return (
    <Board sx={{ padding: theme.spacing(3) }}>
      <Box padding={`${theme.spacing(2)} 0`}>
        <Typography fontSize={16} fontWeight={700} paddingBottom={2}>
          写真の登録にご協力いただき、ありがとうございます。
        </Typography>
        <Typography fontSize={15}>
          キャンプ場の写真は、これからキャンプ場に行く予定の人にとってありがたい情報です。もしこちらのキャンプ場写真をお持ちの場合は、ぜひご登録いただけるとうれしいです！
        </Typography>
        <Stack center padding={4}>
          <Button
            onClick={() => nextPage(`/camp/${campSiteId}/photo`)}
            buttonSize="md"
            color="secondary"
            sx={{
              width: '246px',
            }}
          >
            写真を登録する
          </Button>
        </Stack>
        <Stack column space={2}>
          <Stack
            onClick={() => nextPage('/guideline')}
            sx={{ cursor: 'pointer' }}
          >
            <Icon iconType="arrow-right" color="primary" />
            <Typography fontSize={14} fontWeight={700} color="primary">
              コミュニティガイドラインを確認する
            </Typography>
          </Stack>
        </Stack>
      </Box>
    </Board>
  );
};

export default BeforeUploadPhoto;
